// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__8y4R8"};